import axios from 'axios';

const filenameFromContentDisposition = (header: string | undefined): string | null => {
    if (!header) return null;
    const utf8Match = /filename\*=UTF-8''([^;\s]+)/i.exec(header);
    if (utf8Match?.[1]) {
        try {
            return decodeURIComponent(utf8Match[1].replace(/"/g, ''));
        } catch {
            return utf8Match[1].replace(/"/g, '');
        }
    }
    const quoted = /filename="([^"]+)"/i.exec(header);
    if (quoted?.[1]) return quoted[1];
    const unquoted = /filename=([^;\s]+)/i.exec(header);
    if (unquoted?.[1]) return unquoted[1].replace(/"/g, '');
    return null;
};

/** Отдаёт готовый blob браузеру как файл. */
export const saveBlobAsFile = (blob: Blob, filename: string): void => {
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(objectUrl);
};

/**
 * Скачивает файл по URL через blob (без window.open — не режется блокировщиком всплывающих окон).
 * Для чужого домена нужен CORS, разрешающий чтение ответа с фронта.
 */
export const downloadFileFromUrl = async (url: string, defaultFilename: string): Promise<void> => {
    const response = await axios.get<Blob>(url, {
        responseType: 'blob',
        validateStatus: (status) => status === 200,
    });
    const blob = response.data;
    if (!blob || blob.size === 0) {
        throw new Error('Empty file');
    }
    const header =
        response.headers['content-disposition'] ??
        (response.headers as Record<string, string | undefined>)['Content-Disposition'];
    saveBlobAsFile(blob, filenameFromContentDisposition(header) ?? defaultFilename);
};
